import script from "./SidebarHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarHeader.vue?vue&type=script&setup=true&lang=js"

import "./SidebarHeader.vue?vue&type=style&index=0&id=a75774b6&lang=scss"

const __exports__ = script;

export default __exports__